import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import parse from "html-react-parser";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import axios from "axios";
import { Modal, Button, Table } from "react-bootstrap";
import FilterComponent from "./FilterComponent";
import Alert from "../Common/Alert";
import { useSelector, useDispatch } from "react-redux";
import { convertFirstLetterOfFullNameToCapital } from "../../helpers/commonHelpers";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
import {
  logOut,
  setInValidUser,
} from "../../redux/actions/authActions/authAction";
import downloadLogo from "../../assets/images/wht-download.svg";
import * as constantMessages from "../../constants/constatntMessages";
import { toast } from "react-toastify";
import LoaderButton from "../Common/LoaderButton";
import { handleApiError } from "../../helpers/errorResponseHelper";
import BackButton from "../Common/Backbutton";
import SmallLoaderButton from "../Common/SmallLoaderButton";
import { parseAndDecryptHTML } from "../../helpers/commonHelpers";

const regularExpressionForSearch =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;
const ActivityLogs = React.memo(() => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const organizationId = userData?.organizationId;
  const accessToken = localStorage.getItem("accessToken");
  const [logList, setLogList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(50);
  const [isFetching, setIsFetching] = useState(false);
  const employeeData = useSelector((state) => state.user);
  const totalRemainingItems = totalCount;
  const maxPages = Math.max(1, Math.ceil(totalRemainingItems / limit));
  const [filter, setFilter] = useState(false);
  const [isFilter, setIsFilter] = useState(false); // tracks if filter is applied
  const [searchData, setSearchData] = useState({
    searchKey: "",
    page: 1,
    limit: 50,
    order: -1,
    filterData: {},
  });
  const location = useLocation();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  const [errors, setErrors] = useState({});
  const [showButton, setShowButton] = useState(false);
  const [deleteLogButton, setDeleteLogButton] = useState(false);
  const [idToDelete, setIdToDelete] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDownloadModal, setShowDowanloadModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  useEffect(() => {
    if (authData.isInValidUser && authData.isInvalidUserChecked) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userData");
      localStorage.removeItem("rememberMe");
      dispatch(logOut());
      navigate("/login");
    }
  }, [authData.isInValidUser]);

  useEffect(() => {
    if (employeeData?.userData && employeeData.userData.isAdmin === false) {
      navigate("/page-not-found");
    }
  }, [employeeData?.userData]);

  const fetchLogs = async (bodyData) => {
    try {
      setIsFetching(true);
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
        params: {
          limit: searchData.limit,
          page: searchData.page,
          order: searchData.order,
        },
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/log/viewLogs`,
        bodyData,
        headerObject
      );

      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }

      const logsData = response.data.data || {};

      setLogList(logsData.logsDatas || []);
      setTotalCount(logsData.totalCount || 0);

      if (!logsData?.totalCount && logsData?.totalCount !== 0) {
        setShowButton(false);
        setDeleteLogButton(false);
      }
      const idsArray = logsData?.logsDatas?.map((log) => log._id);

      setIdToDelete(idsArray);
    } catch (error) {
      console.log(error);
      if (handleApiError(error)) return;
    } finally {
      setIsFetching(false);
    }
  };

  const fetchLogData = async (customPayload) => {
    const payload = customPayload || {
      organizationId,

      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
    };

    if (searchData.searchKey?.trim()) {
      payload["searchKey"] = searchData.searchKey.trim();
    }

    if (!payload.organizationId) {
      payload.organizationId = organizationId;
    }

    await fetchLogs(payload);
  };

  useEffect(() => {
    if (!organizationId) return;

    const payload = {
      organizationId,
      fromDate: searchData.filterData?.fromDate,
      toDate: searchData.filterData?.toDate,
    };

    if (searchData.searchKey?.trim()) {
      const errors = {};
      if (!regularExpressionForSearch.test(searchData.searchKey)) {
        errors.searchKey = constantMessages.titleRegexError;
        setErrors(errors);
        return; // stop fetch if error
      } else {
        payload["searchKey"] = searchData.searchKey.trim();
        setErrors({});
      }
    }

    fetchLogData(payload);
  }, [
    organizationId,
    searchData.searchKey,
    searchData.order,
    searchData.page,
    searchData.limit,
    searchData.filterData,
    authData?.isInValidUser,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prev) => {
      const updatedSearchData = {
        ...prev,
        [name]: value,
        page: 1, // Reset page to 1, but leave limit unchanged
      };

      return updatedSearchData;
    });
  };

  // ✅ Clear search
  const handleClearSearch = () => {
    setSearchData((prev) => ({
      ...prev,
      searchKey: "",
      filterData: {},
      page: 1,
    }));
  };

  const handleRowsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setSearchData((prev) => {
      const updatedSearchData = {
        ...prev,
        limit: newLimit, // Update limit value
        page: 1, // Optionally reset page to 1 after changing rows per page
      };

      return updatedSearchData;
    });
  };

  const handlePageChange = (event, value) => {
    setSearchData((prev) => {
      const updatedSearchData = {
        ...prev, // Keep the existing search data
        page: value, // Update the page value
      };

      return updatedSearchData;
    });
  };

  // ✅ Filter application
  const filterData = (data) => {
    setSearchData((prev) => ({
      ...prev,
      filterData: data,
      page: 1,
    }));
    setShowButton(true);
  };

  // ✅ Initial load
  useEffect(() => {
    document.title = "Activity Logs: MinutesVault";
    if (organizationId) {
      fetchLogData();
    }
  }, []);

  const totalOption = totalCount ? Math.ceil(totalCount / 5) : 0;
  const totalPage = totalCount ? Math.ceil(totalCount / searchData.limit) : 0;

  const totalPageArray = Array.from({ length: totalPage }, (_, i) => i);

  const modifiedArray = totalPageArray.filter(
    (index) =>
      index === searchData.page - 1 ||
      (index >= searchData.page && index <= searchData.page + 3)
  );

  const fromDataCount =
    logList.length === 0 ? 0 : (searchData.page - 1) * searchData.limit + 1;
  const toDataCount = (searchData.page - 1) * searchData.limit + logList.length;

  //DownLoad The Filtered Data
  const downloadLogs = async () => {
    try {
      setIsLoading(true);
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
        params: {
          limit: searchData.limit,
          page: searchData.page,
          order: searchData.order,
        },
      };
      const bodyData = {
        organizationId,
        toDate: searchData.filterData?.toDate,
        fromDate: searchData.filterData?.fromDate,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/log/downloadLogs`,
        bodyData,
        {
          ...headerObject,
          responseType: "blob",
        }
      );

      if (response && response.data && response.data.size > 0) {
        setDeleteLogButton(true);
        setShowButton(false);
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ActivityLogs.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("File downloaded successfully!", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      if (handleApiError(error)) return;
      console.log("Error while Fetching Logs:", error);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  };
  //delete The Filtered Data
  const deleteLogs = async (customPayload) => {
    try {
      setIsLoading(true);
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };
      const bodyData = {
        organizationId,
        toDate: searchData.filterData?.toDate,
        fromDate: searchData.filterData?.fromDate,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/log/deleteLogs`,
        bodyData,
        {
          ...headerObject,
          responseType: "blob",
        }
      );
      toast.success("Deleted successfully!", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setShowDeleteModal(false);
      setDeleteLogButton(false);

      const payload = customPayload || {
        organizationId,
      };

      fetchLogData(payload);
    } catch (error) {
      if (handleApiError(error)) return;
    console.log  ("Error while Fetching Logs:", error);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  };

  const handleDownloadClick = () => {
    setShowDowanloadModal(true);
  };

  const handleDowanloadConfirm = async () => {
    try {
      downloadLogs();
    } catch (error) {
      console.error("Error while deleting unit:", error);
    }
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      deleteLogs();
    } catch (error) {
      console.error("Error while deleting unit:", error);
    }
  };

  return (
    <>
      {!accessToken ? <Navigate to="/login" /> : null}
      <div className="main-content">
        <div className="Action-list-page input-width activitylogs-list-page">
          <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
            <h4>Activity Logs</h4>
            <div>
              <BackButton show={camefromPreviousPage} />
            </div>
          </div>
          <FilterComponent
            filter={filter}
            setfilter={setFilter}
            filterData={filterData}
            initData={searchData.filterData}
            isFilter={isFilter}
            setIsFilter={setIsFilter}
            setShowButton={setShowButton}
            setDeleteLogButton={setDeleteLogButton}
          />
          <div className="mt-2 table-box responsive-table ">
            <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">
              <div className="left-tbl-text">
                <p>
                  Showing {fromDataCount} to {toDataCount} of {totalCount}{" "}
                  activities
                </p>
              </div>
              <div className="meeting-f-search width-auto">
                <div className="search-box position-relative">
                  <input
                    type="search"
                    name="searchKey"
                    placeholder="Search By Activity"
                    autoComplete="off"
                    value={searchData.searchKey}
                    onChange={handleChange}
                  />

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#4F2CC8"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                  </svg>

                  {errors?.searchKey && (
                    <span className="error-message position-absolute-error-msg">
                      {errors?.searchKey}
                    </span>
                  )}
                </div>

                <button
                  className="btn add-btn Mom-btn d-flex align-items-center justify-content-center filter-height"
                  id="open-form-btn"
                  onClick={(e) => setFilter(true)}
                >
                  <p>Filter</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-funnel filter-svg"
                    viewBox="0 0 16 16"
                  >
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
                  </svg>
                </button>
                {showButton ? (
                  <button
                    className="create-meeting-button Mom-btn add-btn download-log-btn"
                    id="open-form-btn"
                    onClick={handleDownloadClick}
                  >
                    <p>Download</p>
                    <img src={downloadLogo} className="download-icon" />
                    {}
                  </button>
                ) : null}
                {deleteLogButton ? (
                  <button
                    className="create-meeting-button Mom-btn dlt-log-btn add-btn"
                    id="open-form-btn"
                    onClick={handleDeleteClick}
                  >
                    <p>Delete</p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="16"
                      height="16"
                      viewBox="0 0 427 427.001"
                      fill="#fff"
                      className="delet ms-2"
                    >
                      <g>
                        <path
                          d="M232.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zM114.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                          fill="#fff"
                        />
                        <path
                          d="M28.398 127.121V373.5c0 14.563 5.34 28.238 14.668 38.05A49.246 49.246 0 0 0 78.796 427H268a49.233 49.233 0 0 0 35.73-15.45c9.329-9.812 14.668-23.487 14.668-38.05V127.121c18.543-4.922 30.559-22.836 28.079-41.863-2.485-19.024-18.692-33.254-37.88-33.258h-51.199V39.5a39.289 39.289 0 0 0-11.539-28.031A39.288 39.288 0 0 0 217.797 0H129a39.288 39.288 0 0 0-28.063 11.469A39.289 39.289 0 0 0 89.398 39.5V52H38.2C19.012 52.004 2.805 66.234.32 85.258c-2.48 19.027 9.535 36.941 28.078 41.863zM268 407H78.797c-17.098 0-30.399-14.688-30.399-33.5V128h250v245.5c0 18.813-13.3 33.5-30.398 33.5zM109.398 39.5a19.25 19.25 0 0 1 5.676-13.895A19.26 19.26 0 0 1 129 20h88.797a19.26 19.26 0 0 1 13.926 5.605 19.244 19.244 0 0 1 5.675 13.895V52h-128zM38.2 72h270.399c9.941 0 18 8.059 18 18s-8.059 18-18 18H38.199c-9.941 0-18-8.059-18-18s8.059-18 18-18zm0 0"
                          fill="#fff"
                        />
                        <path
                          d="M173.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </button>
                ) : null}
              </div>
            </div>
            {isFetching ? (
              <div className="meeting-page loader-cont position-relative">
                <Loader />
              </div>
            ) : logList.length > 0 ? (
              <>
                <div className="table-responsive">
                  <Table className="mt-4 table table-bordered table-striped activity-logs-table">
                    <thead>
                      <tr>
                        <th>Sl. No.</th>
                        <th width="100">Menu</th>
                        <th width="170">User Name & IP</th>
                        <th>Action</th>
                        <th>Activity</th>
                        <th>Action Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logList.map((log, index) => (
                        <tr key={log._id}>
                          <td data-label="Sl. No." className="blue-bold-text">
                            {fromDataCount + index}
                          </td>
                          <td data-label="Menu Name">{log.moduleName}</td>
                          <td data-label="User Name">
                            {" "}
                            <p className="ip_address">
                              {log?.userDetail?.name
                                ? convertFirstLetterOfFullNameToCapital(
                                    log?.userDetail?.name
                                  )
                                : null}
                            </p>
                            <p className="detail-date-time">
                              IP Address - {log.ipAddress}
                            </p>
                          </td>
                          <td data-label="Action">
                            <i className="actionTitle"> {log.action}</i>
                          </td>

                          <td
                            data-label="Activity"
                            className="resp-padding-left word-break "
                          >
                            <div className="text-editor c-class">
                              {/* {log.details
                                ? parse(`${log.details.toString()}`)
                                : null} */}
                                <p>
                              {log.details
                                ? parse(parseAndDecryptHTML(log.details))
                                : parse(log.details)}
                                </p>
                            </div>
                            <div className="text-editor">
                              {log.subDetails
                                ? parse(
                                    `</br><p className="detail-date-time">${log.subDetails.toString()}</p>`
                                  )
                                : null}
                            </div>
                          </td>
                          <td
                            data-label="Action Date"
                            className="meeting-td-width-5"
                          >
                            {" "}
                            {log.formattedDate}
                            <p className="detail-date-time">
                              {log.formattedTime}
                            </p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                {totalCount <= 1 ? null : (
                  <div className="tbl-bottom">
                    <div className="left-tbl-bottom">
                      {/* Left Arrow Button */}
                      {searchData.page !== 1 ? (
                        <button
                          className="left-arrow"
                          onClick={(e) =>
                            setSearchData({
                              ...searchData,
                              page: searchData.page - 1,
                            })
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#fff"
                            className="bi bi-chevron-left"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                            />
                          </svg>
                        </button>
                      ) : null}

                      <Stack spacing={2}>
                        <Pagination
                          count={totalPage}
                          page={searchData.page}
                          siblingCount={0}
                          boundaryCount={2}
                          onChange={handlePageChange}
                          hidePrevButton
                          hideNextButton
                          sx={{
                            "& .Mui-selected": {
                              backgroundColor: "#388d27 !important",
                              color: "#fff !important",
                            },
                          }}
                        />
                      </Stack>

                      {searchData.page !== totalPage && (
                        <button
                          className="right-arrow"
                          onClick={() =>
                            setSearchData({
                              ...searchData,
                              page: searchData.page + 1,
                            })
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#fff"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                            />
                          </svg>
                        </button>
                      )}
                    </div>

                    {/* Rows Per Page Selector */}
                    <div className="right-tbl-bottom">
                      <p>Rows Per Page</p>
                      <select
                        className="no-opt-box"
                        name="limit"
                        onChange={handleRowsPerPageChange}
                        value={searchData.limit}
                      >
                        {Number.isInteger(totalOption) &&
                          totalOption > 0 &&
                          Array(totalOption)
                            .fill()
                            .map((_, option) => (
                              <option key={option} value={(option + 1) * 5}>
                                {(option + 1) * 5}
                              </option>
                            ))}
                      </select>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="no-data-img mt-3">
                <>
                  <Alert
                    status={"info"}
                    message={"No data available."}
                    timeoutSeconds={0}
                  />
                  <NoDataFound dataType={"meeting"} />
                  <div className="button-outer">
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        setSearchData({
                          ...searchData,
                          searchKey: "",
                          filterData: {},
                          page: 1,
                        });
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </>
              </div>
            )}
          </div>
        </div>
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this filtered logs?
          </Modal.Body>
          <Modal.Footer>
            {isLoading ? (
              <SmallLoaderButton />
            ) : (
              <Button
                variant=""
                className="add-minutes Mom-btn"
                onClick={handleDeleteConfirm}
              >
                <p>Delete</p>
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          show={showDownloadModal}
          onHide={() => setShowDowanloadModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Download</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to download this filtered logs?
          </Modal.Body>
          <Modal.Footer>
            {isLoading ? (
              <LoaderButton />
            ) : (
              <Button
                variant=""
                className="add-minutes Mom-btn filter-height"
                onClick={handleDowanloadConfirm}
              >
                <p>Download</p>
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
});

export default ActivityLogs;
